/**
 * OrbDocReferenceBehaviorsENOrbDocReferenceBehaviorsENPage
 *
 * Page component for OrbDocReferenceBehaviorsENOrbDocReferenceBehaviorsENPage
 * Path: /docs/reference/behaviors
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocReferenceBehaviorsENDocScreenView as __OrbDocReferenceBehaviorsENDocScreenView } from '@/components/traits/OrbDocReferenceBehaviorsENDocScreenView';
import { OrbDocReferenceBehaviorsENDocAnalyticsView as __OrbDocReferenceBehaviorsENDocAnalyticsView } from '@/components/traits/OrbDocReferenceBehaviorsENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocReferenceBehaviorsENOrbDocReferenceBehaviorsENPageProps {
  // Add any page-level props here
}

export function OrbDocReferenceBehaviorsENOrbDocReferenceBehaviorsENPage(_props: OrbDocReferenceBehaviorsENOrbDocReferenceBehaviorsENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Standard behaviors","description":"The public @almadar/std library: every behavior a program can import with `uses`, by topic.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/reference/behaviors"},{"locale":"ar","path":"/ar/docs/reference/behaviors"},{"locale":"sl","path":"/sl/docs/reference/behaviors"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocReferenceBehaviorsENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocReferenceBehaviorsENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocReferenceBehaviorsENOrbDocReferenceBehaviorsENPage;
